/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Services_Svc_Money_Art_1_StateInputs */

const en_services_svc_money_art_1_state = /** @type {(inputs: Services_Svc_Money_Art_1_StateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Found`)
};

const lv_services_svc_money_art_1_state = /** @type {(inputs: Services_Svc_Money_Art_1_StateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Atrasts`)
};

/**
* | output |
* | --- |
* | "Found" |
*
* @param {Services_Svc_Money_Art_1_StateInputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const services_svc_money_art_1_state = /** @type {((inputs?: Services_Svc_Money_Art_1_StateInputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Services_Svc_Money_Art_1_StateInputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_services_svc_money_art_1_state(inputs)
	return en_services_svc_money_art_1_state(inputs)
});